export default class Employment {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        employmentRetrieve(id: ${id}) {
          id
          user{
            id
            username
            firstName
            lastName
            email
          }
          branchOffice {
            id
            active
            name
            description
            closeTime
            openTime
            phoneNumber
            company {
              id
              name
            }
            address
            locality
            state
            country
            latitude
            longitude
            polygon
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.employmentRetrieve;
  }

  static async all(payload) {
    const response = await payload.axios.post(
      '/graphql/',
      `query{
        employmentList(affiliate: ${payload.affiliate}) {
            id
            user{
              id
              username
              firstName
              lastName
              email
            }
            branchOffice {
              id
              active
              name
              description
              closeTime
              openTime
              phoneNumber
              company {
                id
                name
              }
              address
              locality
              state
              country
              latitude
              longitude
              polygon
            }
          }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.employmentList.reverse();
  }

  static async allOfCompany(axios, company) {
    const response = await axios.post(
      '/graphql/',
      `query {
        employmentCompany(companyId: ${company}) {
          id
          user {
            id
            username
            firstName
            lastName
            email
          }
          branchOffice {
            id
            active
            name
            description
            closeTime
            openTime
            phoneNumber
            company {
              id
              name
            }
            address
            locality
            state
            country
            latitude
            longitude
            polygon
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.employmentCompany;
  }

  static async filter(axios, branchOffice) {
    const response = await axios.post(
      '/graphql/',
      `query{
        employmentList (branchOffice: ${branchOffice}) {
          results {
            id
            user{
              id
              username
              firstName
              lastName
              email
            }
            branchOffice {
              id
              active
              name
              description
              closeTime
              openTime
              phoneNumber
              company {
                id
                name
              }
              address
              locality
              state
              country
              latitude
              longitude
              polygon
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.employmentList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteEmployment(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteEmployment.ok;
  }

  static async create(axios, user, branchOffice) {
    const response = await axios.post(
      '/graphql/',
      `mutation {
        createEmployment(newEmployment: {
          user: ${user}, 
          branchOffice: ${branchOffice}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createEmployment.ok;
  }


  static async edit(axios, id, user, branchOffice) {
    const userField = (user > 0) ? `user: ${user},` : ``;
    const branchOfficeField = (branchOffice > 0) ? `branchOffice: ${branchOffice},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation {
        updateEmployment(newEmployment: {
          ${userField}
          ${branchOfficeField}
          id: ${id},
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateEmployment.ok;
  }


}
